export default __webpack_public_path__ + "static/media/shopifyLock.ecc435c1.svg";